// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.panelTop {
    display: block;
    width: 100%;
    height: 180px;
    border: 1px solid var(--formBorder);
    position: relative;
    overflow: auto;
}

.mychips {
    display: inline-block;
    font-size: 14px;
    height: 32px;
    line-height: 30px;
    border-radius: 20px;
    background-color: var(--chipsBackground);
    cursor: pointer;
    margin: 2px 2px;
}

.mychips mat-icon {
    margin: 5px 5px 5px 5px;
    opacity: 0.5;
    font-size: 20px;
    text-align: center;
}

.mychips span {
    padding-left: 3px;
    padding-right: 3px;
    vertical-align: top;
}
.mychips:hover {
    opacity: 0.9;
}

.mychips-selected {
    background-color: var(--chipSelectedBackground);
    color: var(--chipSelectedColor);
}

.toolbox-toadd {
    position: absolute;
    right: 50px;
    top: -40px;
}

.panelBottom {
    display: block;
    width: 100%;
    height: 300px;
    margin-top: 10px;
}


.list {
    width: 100% !important;
    height: 100% !important;
    font-size: 16px !important;
    padding-top: 0px !important;
}

.list > span {
    padding-left: 10px;
}

.list mat-list-option {
    padding-left: 10px;
}

.list-item {
    display: block;
    font-size: 12px;
    height: 28px !important;
    line-height: 26px;
    cursor: pointer;
    overflow: hidden;
    padding-left: 10px;
}

.list-item mat-icon {
    font-size: 20px;
}

.list-item span {
    text-overflow: ellipsis;
    overflow: hidden;
}

.list-item-text {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.list-item-hover:hover {
    background-color: rgba(0, 0, 0, 0.1);
}


.list-header {
    background-color: rgba(0, 0, 0, 0.8);
    color: #ffffff;
    line-height: 26px;
    cursor: unset;
}

/* Tags Table */
.list-item-remove {
    width: 20px;
    max-width: 20px;
    color:gray;
}

.list-item-name {
    width: 30%;
    max-width: 30%;
}

.list-item-label {
    width: 30%;
    max-width: 30%;
}

.list-item-device {
    width: 30%;
    max-width: 30%;
}

.list-item-color {
    width: 5%;
    max-width: 5%;
    height: 14px;
    border-style: solid;
    border-width: 3px;
}

.list-panel {
    height: calc(100% - 26px); 
    overflow-x: hidden;
}

.device-list {
    margin-right: 2px;
    overflow-y: auto;
}

.tag-list {
    margin-right: 2px;
    overflow-y: auto;
}

.color-line {
    width: 30px;
    border: unset;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    opacity: 1;
    background-color: #f1f3f4;
}
/* Tags Table */




/* Tags Section */
.showEditor {
    display: block;
}

.hideEditor {
    display: none;
}

.section-panel {
    height: 100%;
    font-size: 12px;
}

.section-category {
    width: 25%;
    display: inline-block;
}

.section-header {
    width: 100%;
    background-color: var(--chipsBackground);
    color: #ffffff;
    height: 26px;
    line-height: 26px;
}

.section-header span {
    padding-left: 5px;
}

.section-item {
    width: 100%;
    margin-bottom: 3px;
}

.section-item mat-select {
    width:calc(100% - 7px);
}

.section-list {
    border: 1px solid var(--formBorder);
    height: calc(100% - 30px);
    padding: 2px 2px 2px 2px;
    overflow-x: hidden;
    overflow-y: auto;
}

.section-sources {
    width: 74%;
    float: right;
}
/* Section */
`, "",{"version":3,"sources":["webpack://./src/app/editor/graph-config/graph-config.component.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,WAAW;IACX,aAAa;IACb,mCAAmC;IACnC,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,wCAAwC;IACxC,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,+CAA+C;IAC/C,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,cAAc;IACd,WAAW;IACX,aAAa;IACb,gBAAgB;AACpB;;;AAGA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;AACxC;;;AAGA;IACI,oCAAoC;IACpC,cAAc;IACd,iBAAiB;IACjB,aAAa;AACjB;;AAEA,eAAe;AACf;IACI,WAAW;IACX,eAAe;IACf,UAAU;AACd;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,oCAAoC;IACpC,kBAAkB;IAClB,UAAU;IACV,yBAAyB;AAC7B;AACA,eAAe;;;;;AAKf,iBAAiB;AACjB;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,wCAAwC;IACxC,cAAc;IACd,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mCAAmC;IACnC,yBAAyB;IACzB,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,YAAY;AAChB;AACA,YAAY","sourcesContent":[".panelTop {\n    display: block;\n    width: 100%;\n    height: 180px;\n    border: 1px solid var(--formBorder);\n    position: relative;\n    overflow: auto;\n}\n\n.mychips {\n    display: inline-block;\n    font-size: 14px;\n    height: 32px;\n    line-height: 30px;\n    border-radius: 20px;\n    background-color: var(--chipsBackground);\n    cursor: pointer;\n    margin: 2px 2px;\n}\n\n.mychips mat-icon {\n    margin: 5px 5px 5px 5px;\n    opacity: 0.5;\n    font-size: 20px;\n    text-align: center;\n}\n\n.mychips span {\n    padding-left: 3px;\n    padding-right: 3px;\n    vertical-align: top;\n}\n.mychips:hover {\n    opacity: 0.9;\n}\n\n.mychips-selected {\n    background-color: var(--chipSelectedBackground);\n    color: var(--chipSelectedColor);\n}\n\n.toolbox-toadd {\n    position: absolute;\n    right: 50px;\n    top: -40px;\n}\n\n.panelBottom {\n    display: block;\n    width: 100%;\n    height: 300px;\n    margin-top: 10px;\n}\n\n\n.list {\n    width: 100% !important;\n    height: 100% !important;\n    font-size: 16px !important;\n    padding-top: 0px !important;\n}\n\n.list > span {\n    padding-left: 10px;\n}\n\n.list mat-list-option {\n    padding-left: 10px;\n}\n\n.list-item {\n    display: block;\n    font-size: 12px;\n    height: 28px !important;\n    line-height: 26px;\n    cursor: pointer;\n    overflow: hidden;\n    padding-left: 10px;\n}\n\n.list-item mat-icon {\n    font-size: 20px;\n}\n\n.list-item span {\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n\n.list-item-text {\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n\n.list-item-hover:hover {\n    background-color: rgba(0, 0, 0, 0.1);\n}\n\n\n.list-header {\n    background-color: rgba(0, 0, 0, 0.8);\n    color: #ffffff;\n    line-height: 26px;\n    cursor: unset;\n}\n\n/* Tags Table */\n.list-item-remove {\n    width: 20px;\n    max-width: 20px;\n    color:gray;\n}\n\n.list-item-name {\n    width: 30%;\n    max-width: 30%;\n}\n\n.list-item-label {\n    width: 30%;\n    max-width: 30%;\n}\n\n.list-item-device {\n    width: 30%;\n    max-width: 30%;\n}\n\n.list-item-color {\n    width: 5%;\n    max-width: 5%;\n    height: 14px;\n    border-style: solid;\n    border-width: 3px;\n}\n\n.list-panel {\n    height: calc(100% - 26px); \n    overflow-x: hidden;\n}\n\n.device-list {\n    margin-right: 2px;\n    overflow-y: auto;\n}\n\n.tag-list {\n    margin-right: 2px;\n    overflow-y: auto;\n}\n\n.color-line {\n    width: 30px;\n    border: unset;\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    border-radius: 2px;\n    opacity: 1;\n    background-color: #f1f3f4;\n}\n/* Tags Table */\n\n\n\n\n/* Tags Section */\n.showEditor {\n    display: block;\n}\n\n.hideEditor {\n    display: none;\n}\n\n.section-panel {\n    height: 100%;\n    font-size: 12px;\n}\n\n.section-category {\n    width: 25%;\n    display: inline-block;\n}\n\n.section-header {\n    width: 100%;\n    background-color: var(--chipsBackground);\n    color: #ffffff;\n    height: 26px;\n    line-height: 26px;\n}\n\n.section-header span {\n    padding-left: 5px;\n}\n\n.section-item {\n    width: 100%;\n    margin-bottom: 3px;\n}\n\n.section-item mat-select {\n    width:calc(100% - 7px);\n}\n\n.section-list {\n    border: 1px solid var(--formBorder);\n    height: calc(100% - 30px);\n    padding: 2px 2px 2px 2px;\n    overflow-x: hidden;\n    overflow-y: auto;\n}\n\n.section-sources {\n    width: 74%;\n    float: right;\n}\n/* Section */\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
